import * as types from './notificationActionTypes.js';

export const setCounter = (counter) => ({ type: types.SET_COUNTER, counter: counter });
export const incrementCounter = () => ({ type: types.INCREMENT_COUNTER });
export const incrementCounterBy = (number) => ({ type: types.INCREMENT_COUNTER_BY, number: number });
export const setNotifications= (notifications) => ({ type: types.SET_NOTIFICATIONS, notifications: notifications });
